var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-toolbar',{staticClass:"bottom-toolbar",attrs:{"flat":""}},[_c('osdi-button',{staticStyle:{"padding":"0 4em"},attrs:{"primary":""},on:{"click":_vm.onCreate}},[_c('v-icon',[_vm._v("mdi-plus")]),_vm._v(" "+_vm._s(_vm.createBtnLabel)+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }